import * as Utils from 'atg/utils/Utils';
import StickyTemplate from 'atg/vendor/StickyTemplate/1.0/StickyTemplate';

import DividendReductionView from './grid/DividendReductionView';
import RankingView from './grid/RankingView';

const $ = window.$;

export default class BottomInfo {
  constructor(delegate, $scrollContainer, $parent) {
    this.delegate = delegate;
    this.$scrollContainer = $scrollContainer;
    this.updateContentOnBlur = this.updateContentOnBlur.bind(this);

    const $container = (this.$container = StickyTemplate.jq('bottom-info'));

    $parent.append($container);

    this.$header = $container.find('.header');
    this.$content = $container.find('.content');

    this.$header.find('.tab').event('click', this.onHeaderPressed.bind(this));

    $container.on('click', '[data-locked-overlay]', () =>
      Utils.callDelegate(this.delegate, 'showAlertWhenLocked'),
    );
  }

  onHeaderPressed() {
    let n = this.$scrollContainer.scrollTop();
    this.$container.parentsUntil(this.$scrollContainer).each((i, elm) => {
      n += $(elm).position().top;
    });

    this.$scrollContainer.animate({
      scrollTop: n,
    });
  }

  updateAll() {
    this.updateVisibility();
    this.updateTitle();
    this.updateInfo();
    this.updateContent();
  }

  updateVisibility() {
    const hidden = Utils.callDelegate(this.delegate, 'getBottomInfoHidden');

    if (hidden) {
      this.$container.hide();
    } else {
      this.$container.show();
    }
  }

  updateTitle() {
    const $title = this.$header.find('.title');
    const title = Utils.callDelegate(this.delegate, 'getBottomInfoTitle');

    $title.text(title);
  }

  updateContent() {
    const $active = $(document.activeElement);

    if (
      $active.is('input, select, textarea') &&
      this.$content.get(0).contains($active.get(0))
    ) {
      $active.reevent('blur', this.updateContentOnBlur);
      return;
    }

    const fragment = document.createDocumentFragment();

    const $jq = Utils.callDelegate(this.delegate, 'getBottomInfoContent');

    if ($jq && $jq.length > 0) {
      for (const element of $jq) {
        fragment.append(element);
      }
    }

    this.$content.empty().append(fragment);

    setTimeout(() => {
      this.updateLockedState();
    }, 0);
  }

  updateLockedState() {
    // Do not lock ranking/result view
    const isRankingView = this.delegate instanceof RankingView;
    // Partially lock dividend reduction view
    const isDividendReductionView =
      this.delegate instanceof DividendReductionView;

    const isLocked =
      !isRankingView && Utils.callDelegate(this.delegate, 'isBetBlocked');

    const overlayClassName = isDividendReductionView
      ? '.locked-overlay-part'
      : '.locked-overlay';

    if (isDividendReductionView) {
      $('.locked-overlay').hide();
    }

    if (isLocked) {
      $(overlayClassName).show();
    } else {
      $(overlayClassName).hide();
    }
  }

  updateContentOnBlur(event) {
    const $active = $(event.currentTarget);
    $active.unevent('blur', this.updateContentOnBlur);
    this.updateContent();
  }

  updateInfo() {
    if (IS_NO_SITE) {
      return; // Norwegian site doesn't have any turnover info to show
    }
    const $header = this.$header;

    const $label = $header.find('.info-label');
    const label = Utils.callDelegate(this.delegate, 'getBottomInfoInfoLabel');
    $label.text(label);

    const $items = $header.find('.info-items');
    $items.empty();

    const turnovers = Utils.callDelegate(
      this.delegate,
      'getBottomInfoInfoItems',
    );

    if (turnovers) {
      for (const turnover of turnovers) {
        const $item = StickyTemplate.jq('bottom-info-header-info-item', {
          '.label': turnover.label,
          '.value': turnover.value,
        });

        $item.addClass(`race-${Utils.wrapRaceNumber(turnover.raceNumber)}`);

        $items.append($item);
      }
    }
  }
}
